import React from 'react';
import { HeadingSBold } from 'components/Typography/Typography';
import ValueCell from './ValueCell';

interface ISimpleValueCellProps {
	value: string;
	subtitle?: string;
	title?: string;
	backgroundColor?: types.newServices.backgroundColor;
	minHeight?: number;
}

const SimpleValueCell = (props: ISimpleValueCellProps) => {
	return <ValueCell {...props} value={<HeadingSBold disableMargin>{props.value}</HeadingSBold>} />;
};

export default SimpleValueCell;
